module.exports = __webpack_public_path__ + "static/media/med-ico-purple.b82b1208.svg";